import styled from 'styled-components';

export const BannerContainer = styled.div`
  width: 100%;
  background-color: #F8EEFF;
  border-radius: 0;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #F3E1FF;
  }
`;

export const BannerContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  width: 100%;
`;

export const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const SharedWithMeIcon = styled.img`
  width: 24px;
  height: 24px;
  flex-shrink: 0;
`;

export const SharedWithMeLinkText = styled.span`
  color: #1e252a;
  font-size: 16px;
  font-family: IBM Plex Sans;
  font-weight: 500;
  white-space: nowrap;
`;

export const ViewText = styled.span`
  color: #7200e0;
  font-size: 16px;
  font-family: IBM Plex Sans;
  font-weight: 500;
  white-space: nowrap;
`;

export const CountInParentheses = styled.span`
  color: #7200e0;
  font-size: 16px;
  font-family: IBM Plex Sans;
  font-weight: 500;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s;
  margin-left: 8px;
  
  &:hover {
    opacity: 0.7;
  }
  
  &:focus {
    outline: none;
  }
`;

export const CloseIcon = styled.img`
  width: 20px;
  height: 20px;
`;

